import { POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function verifyLogin(usuario, password) {
  try {
    let data = { error: true };
    const {
      code,
      body,
      message,
      idEmpresa,
      idRolUsuarioWeb,
      idTipoUsuarioWeb,
      idUsuario,
    } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/autenticacion/login-web",
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: POST,
        body: JSON.stringify({ usuario, password }),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.body = body;
      data.idEmpresa = idEmpresa;
      data.idRolUsuarioWeb = idRolUsuarioWeb;
      data.idTipoUsuarioWeb = idTipoUsuarioWeb;
      data.idUsuario = idUsuario;
    } else {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("verifyLogin err");
    console.log(err);
    return { error: true };
  }
}

export async function getUserInfo() {
  try {
    let data = null;
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/autenticacion/user-info",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify({}),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data = body;
    }
    return data;
  } catch (err) {
    console.log("getUserInfo err");
    console.log(err);
    return null;
  }
}

export async function obtenerInfoUsuario() {
  try {
    let data = null;
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/autenticacion/obtener-info-usuario",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify({}),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      if (Array.isArray(body) && body.length > 0) {
        data = body[0];
      }
    }
    return data;
  } catch (err) {
    console.log("obtenerInfoUsuario err");
    console.log(err);
    return null;
  }
}
